import React from 'react';
import { defaultFont, themedText } from '../styles/SharedStyles';
import { useThemeContext } from '../context';

export function NoRootAccess(): JSX.Element {
  const theme = useThemeContext();
  return (
    <p style={{ ...defaultFont, margin: '10px', ...themedText(theme) }}>
      There is no root access to this application.
    </p>
  );
}
